<div class="expandable">

    <div class="header">
        <h5>
            <i class="hgi hgi-stroke text-primary" [ngClass]="icone"></i>
            {{ titulo }}
            <div class="alertas" *ngIf="showAlertas">
                <span>{{ alertas }}</span>
            </div>
        </h5>

        <div class="options">
            <button type="button" class="btn btn-outline-secondary" (click)="toggleExpand()">
                <i class="hgi hgi-stroke" [ngClass]="expanded ? 'hgi-arrow-down-01' : 'hgi-arrow-up-01'"></i>
            </button>
        </div>
    </div>

    <div class="content" *ngIf="expanded">
        <ng-content></ng-content>
    </div>

</div>
